module.exports = __webpack_public_path__ + "static/media/bird2.f07795f5.jpg";